import { Projects } from '../project-list';

export const Tictactoe: Projects = {
  id: 6,
  name: 'Tic-Tac-Toe',
  title: 'Tic-Tac-Toe: The Best Introduction to a Language',
  timeLine: 'September 2019 - Present',
  myRole: 'Software Engineer',
  team: 'Just me!',
  technology: 'Java, Angular, Python, and Swift',
  content: 'Coming Soon...',
  // <hr><h2>Introduction</h2><p></p>
  description: 'Coming Soon...',
  key: 'Tictactoe',
  date: 'September 2019 - Present',
  imageUrl: 'assets/Images/tictactoe.png',
  buttonText: 'View Code',
  buttonUrl: 'https://github.com/manasvimedam/TicTacToe',
};
